import "./Button.css";

export default function Button() {
  return (
    <button href="" className="sliding-button">
     <span className="justOMG">Button</span>
    </button>
  );
}